/*  Ladybugg's Cottage — theme.js
 *  ------------------------------------------------------------------
 *  Cart:      Shopify AJAX Cart API (/cart.js, /cart/add.js, /cart/change.js)
 *  Search:    Shopify Predictive Search API
 *  Options:   variant options switch product variants; list options post as
 *             line item properties (see main-product.liquid for the rationale)
 *  Flourish:  ladybug cursor, drifting petals, butterflies, scroll reveals
 *  ------------------------------------------------------------------ */
(function () {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cfg = window.LBC || {};
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = matchMedia('(pointer: fine)').matches;

  /* ---------------- money ---------------- */
  function money(cents) {
    const fmt = cfg.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, withCommas);
  }
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------------- toast ---------------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 2600);
  }

  /* ================= CART (Shopify AJAX API) ================= */
  const Cart = {
    async get() {
      const r = await fetch(`${cfg.routes.cart}.js`, { headers: { Accept: 'application/json' } });
      return r.json();
    },
    async add(formData) {
      const r = await fetch(`${cfg.routes.cartAdd}.js`, {
        method: 'POST', headers: { Accept: 'application/json' }, body: formData
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Add to cart failed');
      }
      return r.json();
    },
    async change(line, quantity) {
      const r = await fetch(`${cfg.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      return r.json();
    }
  };

  function renderCart(cart) {
    const box = $('#cart-items');
    const foot = $('#cart-foot');
    if (!box) return;
    updateBadges(cart.item_count);

    if (!cart.item_count) {
      box.innerHTML = `<div class="empty-nest">
        <span class="big">🧺</span>
        <span class="script">${esc(cfg.strings.empty)}</span>
        <a class="btn btn-berry btn-small" href="/collections/all">${esc('Browse the shop')}</a>
      </div>`;
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    box.innerHTML = cart.items.map((item, i) => {
      const opts = [];
      if (item.options_with_values) {
        item.options_with_values.forEach((o) => {
          if (o.value && o.value !== 'Default Title') opts.push(`${esc(o.name)}: <strong>${esc(o.value)}</strong>`);
        });
      }
      if (item.properties) {
        Object.keys(item.properties).forEach((k) => {
          if (k.charAt(0) !== '_' && item.properties[k]) opts.push(`${esc(k)}: <strong>${esc(item.properties[k])}</strong>`);
        });
      }
      const discounts = (item.line_level_discount_allocations || [])
        .map((d) => `<span class="deal-line">🐞 ${esc(d.discount_application.title)} (−${money(d.amount)})</span>`).join('');
      const img = item.image
        ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" loading="lazy">`
        : '<svg><use href="#i-cam"/></svg>';

      return `<div class="cart-line">
        <a class="cart-thumb" href="${item.url}">${img}</a>
        <div class="cl-body">
          <h4><a href="${item.url}">${esc(item.product_title)}</a></h4>
          <div class="cl-opts">${opts.join('<br>')}</div>
          ${discounts}
          <div class="cl-row">
            <div class="qty mini">
              <button type="button" data-line="${i + 1}" data-to="${item.quantity - 1}" aria-label="One less">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-line="${i + 1}" data-to="${item.quantity + 1}" aria-label="One more">+</button>
            </div>
            <span class="cl-price">${money(item.final_line_price)}</span>
          </div>
          <button type="button" class="link-btn" data-line="${i + 1}" data-to="0">remove</button>
        </div>
      </div>`;
    }).join('');

    // Bundle / automatic discounts come straight from Shopify
    const savings = (cart.cart_level_discount_applications || [])
      .reduce((sum, d) => sum + d.total_allocated_amount, 0)
      + cart.items.reduce((sum, it) =>
        sum + (it.line_level_discount_allocations || []).reduce((s, d) => s + d.amount, 0), 0);

    const row = $('#pair-savings');
    if (row) {
      row.hidden = savings <= 0;
      const amt = $('#pair-amt');
      if (amt) amt.textContent = '−' + money(savings);
    }
    const sub = $('#cart-subtotal');
    if (sub) sub.textContent = money(cart.total_price);
  }

  function updateBadges(count) {
    const c = $('#cart-count');
    if (c) { c.textContent = count; c.classList.toggle('show', count > 0); }
    const w = $('#wish-count');
    if (w) { const n = Wishlist.all().length; w.textContent = n; w.classList.toggle('show', n > 0); }
  }

  async function refreshCart(open) {
    try {
      const cart = await Cart.get();
      renderCart(cart);
      if (open) openCart();
    } catch (e) { /* cart stays as-is */ }
  }

  /* drawer */
  function openCart() {
    const d = $('#cart-drawer');
    if (!d) return;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    const v = $('#veil'); if (v) v.classList.add('show');
  }
  function closeCart() {
    const d = $('#cart-drawer');
    if (!d) return;
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true');
    const v = $('#veil'); if (v) v.classList.remove('show');
  }
  function closeAll() {
    closeCart(); closeSearch();
    const nav = $('#main-nav'); if (nav) nav.classList.remove('open');
    const mb = $('#menu-btn'); if (mb) mb.setAttribute('aria-expanded', 'false');
  }

  /* ================= WISHLIST (sessionStorage-free, cookie-light) ================= */
  const Wishlist = {
    key: 'lbc_favorites',
    all() {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
    },
    has(handle) { return this.all().indexOf(handle) > -1; },
    toggle(handle) {
      const list = this.all();
      const i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1); else list.push(handle);
      try { localStorage.setItem(this.key, JSON.stringify(list)); } catch (e) {}
      return i === -1;
    }
  };

  function paintHearts() {
    $$('[data-love]').forEach((b) => {
      const on = Wishlist.has(b.dataset.love);
      b.classList.toggle('loved', on);
      b.setAttribute('aria-pressed', on);
    });
    updateBadges(document.querySelector('#cart-count') ? +$('#cart-count').textContent : 0);
  }

  /* Fetch a single product card. Returns ONLY the .card element's markup — never
     whatever else the response contained. Without this guard, a response that is a
     full page (e.g. a bad handle returning a 404/listing page) would inject a second
     header, nav and footer into the middle of the page. */
  async function fetchCard(handle) {
    if (!handle) return '';
    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}?view=card`);
      if (!res.ok) return '';
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      if (doc.querySelector('header.site, footer.site, #cart-drawer')) return ''; // full page — reject
      const card = doc.querySelector('.card');
      return card ? card.outerHTML : '';
    } catch (e) { return ''; }
  }

  async function renderFavorites() {
    const grid = $('#wish-grid');
    if (!grid) return;
    const handles = Wishlist.all();
    const empty = $('#wish-empty');
    if (!handles.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    const cards = await Promise.all(handles.map(fetchCard));
    grid.innerHTML = cards.filter(Boolean).join('');
    paintHearts();
  }

  /* ================= RECENTLY VIEWED ================= */
  const Recent = {
    key: 'lbc_recent',
    all() { try { return JSON.parse(sessionStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    push(handle) {
      if (!handle) return;                 // never store an empty handle
      let list = this.all().filter((h) => h !== handle);
      list.unshift(handle);
      list = list.slice(0, 8);
      try { sessionStorage.setItem(this.key, JSON.stringify(list)); } catch (e) {}
    }
  };

  async function renderRecent() {
    // The original site showed this strip on the home view (#home-recent) and under
    // the product page (#recent-strip); support both.
    const wrap = $('#recent-wrap') || $('#home-recent-wrap');
    const strip = $('#recent-strip') || $('#home-recent');
    if (!wrap || !strip) return;
    const current = document.body.dataset.productHandle;
    const list = Recent.all().filter((h) => h !== current).slice(0, 6);
    if (!list.length) return;
    const cards = await Promise.all(list.map(fetchCard));
    const html = cards.filter(Boolean).join('');
    if (html) { strip.innerHTML = html; wrap.hidden = false; paintHearts(); }
  }

  /* ================= PRODUCT PAGE =================
     High-variant safe. Option state lives with Shopify: selecting a value asks
     the Section Rendering API to re-render this section with
     ?option_values=<ids>, so price, availability and the variant id always come
     from Shopify — never from a truncated client-side variant list. */
  function initProduct() {
    const form = $('#product-form');
    if (!form) return;

    const info = $('[data-section-id][data-product-url]');
    const sid = info ? info.dataset.sectionId : '';
    const productUrl = info ? info.dataset.productUrl : window.location.pathname;

    Recent.push(document.body.dataset.productHandle || '');

    const qtyInput = () => $('#qty-input');
    function getQty() {
      const i = qtyInput();
      if (!i) return 1;
      let v = parseInt(i.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 99) v = 99;
      i.value = v;
      return v;
    }
    function syncLinePrice() {
      const el = $('#line-price');
      if (!el) return;
      const unit = parseInt(el.dataset.unitPrice, 10);
      if (!isNaN(unit)) el.textContent = money(unit * getQty());
    }

    let fetching = false;
    async function refreshOptions(clickedId) {
      const wrap = $('.optionValueSelectors');
      if (!wrap || fetching || !sid) return;   // no section id => never request a full page
      fetching = true;
      wrap.classList.add('loading');
      try {
        const ids = $$('[data-option-value-id].on', wrap).map((b) => b.dataset.optionValueId);
        const params = ids.length ? `&option_values=${ids.join(',')}` : '';
        const res = await fetch(`${productUrl}?section_id=${sid}${params}`);
        if (!res.ok) throw new Error('section fetch failed');
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        const freshOptions = doc.querySelector('.optionValueSelectors');
        if (freshOptions) wrap.innerHTML = freshOptions.innerHTML;

        // price, stock line, add button and variant id all come back from Shopify
        ['#price-' + sid, '#stock-' + sid, '#add-label-' + sid].forEach((sel) => {
          const from = doc.querySelector(sel), to = $(sel);
          if (from && to) to.innerHTML = from.innerHTML;
        });
        const freshId = doc.querySelector('input[name="id"]');
        const idField = $('input[name="id"]');
        if (freshId && idField) {
          idField.value = freshId.value;
          idField.disabled = freshId.hasAttribute('disabled');
        }
        const freshBtn = doc.querySelector('#add-cart');
        const btn = $('#add-cart');
        if (freshBtn && btn) btn.disabled = freshBtn.hasAttribute('disabled');
        const freshPrice = doc.querySelector('#line-price');
        const linePrice = $('#line-price');
        if (freshPrice && linePrice) linePrice.dataset.unitPrice = freshPrice.dataset.unitPrice;
        syncLinePrice();

        if (clickedId) {
          const again = wrap.querySelector(`[data-option-value-id="${clickedId}"]`);
          if (again) again.focus();
        }
      } catch (e) {
        /* keep the current selection visible if the refresh fails */
      } finally {
        fetching = false;
        wrap.classList.remove('loading');
      }
    }

    // One delegated listener on the form — never stacks across renders.
    form.addEventListener('click', (e) => {
      const ob = e.target.closest('[data-opt]');
      if (ob) {
        const block = ob.closest('[data-option-block]');
        const val = ob.dataset.val;
        block.querySelectorAll('[data-opt]').forEach((b) => {
          const on = b === ob;
          b.classList.toggle('on', on);
          if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', on);
          if (b.hasAttribute('aria-selected')) b.setAttribute('aria-selected', on);
        });
        const picked = block.querySelector('[data-picked]');
        if (picked) picked.textContent = val;
        const panel = ob.closest('.scent-panel');
        if (panel) {
          panel.classList.remove('open');
          const tg = block.querySelector('.scent-toggle');
          if (tg) tg.setAttribute('aria-expanded', 'false');
        }
        refreshOptions(ob.dataset.optionValueId);
        return;
      }
      const tg = e.target.closest('.scent-toggle');
      if (tg) {
        const panel = tg.nextElementSibling;
        const open = panel.classList.toggle('open');
        tg.setAttribute('aria-expanded', open);
        if (open) { const inp = panel.querySelector('input'); if (inp) inp.focus(); }
        return;
      }
      const q = e.target.closest('[data-q]');
      if (q) {
        const i = qtyInput();
        if (i) { i.value = Math.max(1, Math.min(99, getQty() + parseInt(q.dataset.q, 10))); syncLinePrice(); }
      }
    });

    form.addEventListener('input', (e) => {
      if (e.target.id === 'qty-input') { syncLinePrice(); return; }
      if (e.target.closest('.scent-panel')) {
        const q = e.target.value.toLowerCase();
        e.target.closest('.scent-panel').querySelectorAll('.scent-list button').forEach((b) => {
          b.style.display = b.textContent.toLowerCase().indexOf(q) > -1 ? '' : 'none';
        });
      }
    });

    form.addEventListener('change', (e) => {
      if (e.target.id === 'qty-input') { getQty(); syncLinePrice(); }
      if (e.target.dataset.addonLabel !== undefined) {
        const hidden = $('[id^="addon-input-"]');
        if (hidden) {
          hidden.disabled = !e.target.checked;
          hidden.value = e.target.checked ? e.target.dataset.addonLabel : '';
        }
      }
    });

    $$('.thumb.has-img').forEach((t) => t.addEventListener('click', () => {
      const main = $('.main-frame img.p-art');
      if (main && t.dataset.thumb) main.src = t.dataset.thumb;
    }));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = $('#add-cart');
      if (btn) { btn.disabled = true; btn.classList.add('loading'); }
      try {
        await Cart.add(new FormData(form));
        await refreshCart(true);
        toast(cfg.strings.added);
      } catch (err) {
        toast(err.message);
      } finally {
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
      }
    });

    syncLinePrice();
  }

  /* ================= SEARCH (Predictive Search API) ================= */
  function openSearch() {
    const v = $('#search-veil');
    if (!v) return;
    v.classList.add('open'); v.setAttribute('aria-hidden', 'false');
    setTimeout(() => { const i = $('#big-search'); if (i) i.focus(); }, 60);
  }
  function closeSearch() {
    const v = $('#search-veil');
    if (!v) return;
    v.classList.remove('open'); v.setAttribute('aria-hidden', 'true');
  }

  let searchTimer;
  function initSearch() {
    const input = $('#big-search');
    if (!input) return;
    const results = $('#search-results');

    input.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const url = `${cfg.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,page&resources[limit]=6&section_id=predictive-search`;
          const r = await fetch(url);
          if (r.ok) {
            const text = await r.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const inner = doc.querySelector('#predictive-results');
            results.innerHTML = inner ? inner.innerHTML : '';
          }
        } catch (e) { /* keep last results */ }
      }, 220);
    });
  }

  /* ================= SCROLL REVEALS ================= */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((x) => {
          if (x.isIntersecting) { x.target.classList.add('revealed'); io.unobserve(x.target); }
        });
      }, { threshold: 0.12 })
    : null;
  function observeReveals() {
    if (!io) { $$('.reveal').forEach((r) => r.classList.add('revealed')); return; }
    $$('.reveal:not(.revealed)').forEach((r) => io.observe(r));
  }

  /* ================= AMBIENT: petals, butterflies, sparkles ================= */
  const PETALS = ['#E2A4B1', '#EFC3CC', '#E8B7A0', '#D98E9E'];
  function spawnPetal() {
    if (reduceMotion || document.hidden || cfg.ambientEnabled === false) return;
    const amb = $('#ambient');
    if (!amb || amb.children.length > 14) return;
    const d = document.createElement('div');
    d.className = 'petal';
    const size = 9 + Math.random() * 11;
    const dur = 9 + Math.random() * 9;
    d.style.left = Math.random() * 100 + 'vw';
    d.style.setProperty('--spin', (140 + Math.random() * 260) + 'deg');
    d.style.animationDuration = dur + 's';
    const c = PETALS[Math.floor(Math.random() * PETALS.length)];
    const svg = Math.random() > 0.35
      ? `<svg width="${size}" height="${size * 1.25}" viewBox="0 0 20 25"><path d="M10 0C16 6 20 12 10 25 0 12 4 6 10 0Z" fill="${c}" opacity=".85"/></svg>`
      : `<svg width="${size * 1.3}" height="${size}" viewBox="0 0 26 16"><path d="M1 15C4 4 14 0 25 3 20 12 10 17 1 15Z" fill="#8fa065" opacity=".8"/></svg>`;
    d.innerHTML = `<span class="petal-inner" style="--sway:${14 + Math.random() * 22}px;animation-duration:${2.4 + Math.random() * 2}s">${svg}</span>`;
    amb.appendChild(d);
    setTimeout(() => d.remove(), dur * 1000 + 200);
  }

  function spawnButterflies() {
    if (reduceMotion || cfg.ambientEnabled === false) return;
    const hero = $('.hero');
    if (!hero) return;
    [['#E3AF35', 26, 0], ['#E2A4B1', 34, -9]].forEach(([c, dur, delay]) => {
      const b = document.createElement('div');
      b.className = 'butterfly';
      b.style.setProperty('--dur', dur + 's');
      b.style.animationDelay = delay + 's';
      b.innerHTML = `<svg viewBox="0 0 34 30"><g>
        <path d="M17 15C11 4 2 2 1 8c-1 5 6 10 16 7Z" fill="${c}" opacity=".9"/>
        <path d="M17 15C23 4 32 2 33 8c1 5-6 10-16 7Z" fill="${c}" opacity=".9"/>
        <path d="M17 15C12 26 4 28 3 23c-1-4 5-8 14-8Z" fill="${c}" opacity=".7"/>
        <path d="M17 15c5 11 13 13 14 8 1-4-5-8-14-8Z" fill="${c}" opacity=".7"/>
        <rect x="16" y="7" width="2" height="16" rx="1" fill="#54381F"/></g></svg>`;
      hero.appendChild(b);
    });
    [['12%', '30%', 0], ['86%', '24%', 1.1], ['8%', '68%', 2.2], ['90%', '62%', 0.6], ['22%', '14%', 1.7], ['76%', '78%', 2.8]]
      .forEach(([x, y, delay]) => {
        const s = document.createElement('span');
        s.className = 'sparkle';
        s.style.left = x; s.style.top = y; s.style.animationDelay = delay + 's';
        s.innerHTML = '<svg viewBox="0 0 10 10" width="9" height="9"><path d="M5 0l1.2 3.8L10 5 6.2 6.2 5 10 3.8 6.2 0 5l3.8-1.2Z" fill="currentColor"/></svg>';
        hero.appendChild(s);
      });
  }

  /* ================= LADYBUG CURSOR ================= */
  function initCursor() {
    if (!finePointer || reduceMotion || cfg.cursorEnabled === false) return;
    const bug = $('#bug-cursor');
    if (!bug) return;
    const rot = bug.querySelector('.bug-rot');
    let tx = innerWidth / 2, ty = innerHeight / 2, x = tx, y = ty, ang = 0, shown = false;
    document.body.classList.add('cursor-on');

    addEventListener('mousemove', (e) => {
      tx = e.clientX; ty = e.clientY;
      if (!shown) { bug.classList.add('on'); shown = true; }
    });
    addEventListener('mouseleave', () => { bug.classList.remove('on'); shown = false; });
    addEventListener('mousedown', () => bug.classList.add('pressing'));
    addEventListener('mouseup', () => bug.classList.remove('pressing'));
    document.addEventListener('mouseover', (e) => {
      bug.classList.toggle('hovering', !!e.target.closest('a,button,input,select,textarea,summary,label,.card'));
    });

    (function loop() {
      const dx = tx - x, dy = ty - y;
      x += dx * 0.22; y += dy * 0.22;
      if (Math.hypot(dx, dy) > 1.5) {
        const target = Math.atan2(dy, dx) * 180 / Math.PI + 90;
        const diff = ((target - ang + 540) % 360) - 180;
        ang += diff * 0.15;
      }
      bug.style.transform = `translate(${x}px,${y}px)`;
      if (rot) rot.setAttribute('transform', `rotate(${ang} 17 17)`);
      requestAnimationFrame(loop);
    })();
  }

  /* ================= GLOBAL WIRING ================= */
  document.addEventListener('click', async (e) => {
    // wishlist hearts
    const lb = e.target.closest('[data-love]');
    if (lb) {
      e.preventDefault();
      const added = Wishlist.toggle(lb.dataset.love);
      toast(added ? cfg.strings.savedFav : cfg.strings.removedFav);
      paintHearts();
      if ($('#wish-grid')) renderFavorites();
      return;
    }
    // cart line quantity
    const line = e.target.closest('[data-line]');
    if (line) {
      e.preventDefault();
      const cart = await Cart.change(+line.dataset.line, +line.dataset.to);
      renderCart(cart);
      return;
    }
    // scent panels close on outside click
    if (!e.target.closest('.scent-picker')) {
      $$('.scent-panel.open').forEach((p) => {
        p.classList.remove('open');
        const tg = p.parentElement.querySelector('.scent-toggle');
        if (tg) tg.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  function initChrome() {
    const cartBtn = $('#cart-btn');
    if (cartBtn) cartBtn.addEventListener('click', (e) => { e.preventDefault(); refreshCart(true); });
    const cartClose = $('#cart-close'); if (cartClose) cartClose.addEventListener('click', closeCart);
    const veil = $('#veil'); if (veil) veil.addEventListener('click', closeAll);
    const sBtn = $('#search-btn'); if (sBtn) sBtn.addEventListener('click', openSearch);
    const sClose = $('#search-close'); if (sClose) sClose.addEventListener('click', closeSearch);

    const menuBtn = $('#menu-btn');
    if (menuBtn) menuBtn.addEventListener('click', () => {
      const nav = $('#main-nav');
      const open = nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });

    // collection sort auto-submits
    const sort = $('#shop-sort');
    if (sort) sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    // policy agreement gates checkout (drawer + cart page)
    [['#agree-check', '#agree-line', '#checkout-btn'], ['#agree-check-page', '#agree-line-page', '#checkout-btn-page']]
      .forEach(([boxSel, lineSel, btnSel]) => {
        const box = $(boxSel), lineEl = $(lineSel), btn = $(btnSel);
        if (!box || !btn) return;
        btn.addEventListener('click', (e) => {
          if (!box.checked) {
            e.preventDefault();
            if (lineEl) lineEl.classList.add('attention');
            toast(cfg.strings.agree);
            box.focus();
          }
        });
        box.addEventListener('change', () => {
          if (box.checked && lineEl) lineEl.classList.remove('attention');
        });
      });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    initChrome();
    initProduct();
    initSearch();
    initCursor();
    observeReveals();
    spawnButterflies();
    paintHearts();
    renderFavorites();
    renderRecent();
    refreshCart(false);
    if (!reduceMotion && cfg.ambientEnabled !== false) {
      setInterval(spawnPetal, 1900);
      setTimeout(spawnPetal, 700);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme Editor support — re-init when sections are re-rendered
  document.addEventListener('shopify:section:load', () => {
    initChrome(); initProduct(); initSearch(); observeReveals(); paintHearts();
  });
})();
